// extracted by mini-css-extract-plugin
export default {"badgeButton":"ButtonBadge_badgeButton__-vIiG","badgeIcon":"ButtonBadge_badgeIcon__D+rqC"};